import React from 'react';

import { SidebarItemsType } from '../../types/sidebar';
import SidebarNavList from './SidebarNavList';

type SidebarNavSectionProps = {
  pages: SidebarItemsType[];
  title?: string;
};

const SidebarNavSection: React.FC<SidebarNavSectionProps> = (props) => {
  const { pages } = props;

  return (
    <SidebarNavList pages={pages} depth={0} />
  );
};

export default SidebarNavSection;
